<template>
  <div class="row" v-if="dataLoaded">
    <v-col lg=4 sm=6 cols=12>
      <v-card color="primary" class="ma-1" style="text-align: left">
        <v-card-title class="pa-5 pb-3" color="fontDefault">
          <p class="income-title">{{ popLast(languageData.labels.totalProjects) }} <br> {{ splitWord(languageData.labels.totalProjects) }}</p>
          <p class="income-title"></p>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pa-5 pt-0">
          <v-row no-gutters>
            <v-col cols="12" class="my-auto">
              <span class="income-value" style="font-size: 42px">{{ topSection.projectCount }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col lg=4 sm=6 cols=12>
      <v-card color="white" class="ma-1">
        <v-card-title class="pa-5 pb-3" color="fontDefault">
          <p class="income-title">{{ popLast(languageData.labels.totalInvoices) }} <br> {{ splitWord(languageData.labels.totalInvoices) }} <span class="caption income-span">({{ topSection.invoices.count }})</span></p>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pa-5 pt-0">
          <v-row no-gutters>
            <v-col cols="12" class="my-auto">
              <span class="income-value" style="font-size: 42px">{{ topSection.invoices.sum }}<span class="income-currency ml-2">&euro;</span> </span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col lg=4 sm=6 cols=12>
      <v-card color="success" class="ma-1">
        <v-card-title class="pa-5 pb-3" color="fontDefault">
          <p class="income-title">{{ popLast(languageData.labels.totalPaidInvoices) }} <br> {{ splitWord(languageData.labels.totalPaidInvoices) }} <span class="caption income-span">({{ topSection.paidInvoices.count }})</span></p>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pa-5 pt-0">
          <v-row no-gutters>
            <v-col cols="12" class="my-auto">
              <span class="income-value" style="font-size: 42px">{{ topSection.paidInvoices.sum }}<span class="income-currency ml-2">&euro;</span> </span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import splitHelper from "../../../../../helpers/splitHelper";

export default {
  name: "TopSection",
  data() {
    return {
      splitWord: splitHelper.splitHelper,
      popLast: splitHelper.popLastHelper,
    }
  },
  computed: {
    ...mapState("getDashboardData", {
      topSection: state => state.topSection,
      dataLoaded: state => state.dataLoaded,
    })
  }
}
</script>

<style scoped>

</style>